import React from 'react';
import { Link } from 'react-router-dom';
import BrandCross from './BrandCross';

export default function Logo() {
  return (
    <Link to="/" className="brand" aria-label="Indabo za Mariya home">
      <BrandCross />
      <span className="brand-name">INDABO ZA MARIYA</span>
    </Link>
  );
}
